import React, { useState, useRef, useEffect } from 'react';
import DetailIcon from '@/common/detail-icon';
import { resetUrl, getUrl } from '../../../common/reset-image';
import doLog from '../../../common/log';
import { throttle } from '@/common/throttle';
import './index.less';
import SkuStore from '@/stores/sku';


interface PropTypes {
  mediaItems: [Partial<ImageInterface>];
  activeId: number;
  setActiveId: (i: number) => void;
}

// const SHOW_ITEMS_NUMBER = 7;
//img-list的小正方形图片height 64px + margin-bottom 20px
const ITEMS_HEIGHT = 84;

export default function ImageList(props: PropTypes) {
  const { setActiveId, activeId, mediaItems } = props;
  //滑动距离
  const [swipeDistance, setSwipeDistance] = useState(0);
  //商品图片列表的长度，也是图片的个数
  const ImageListLength = mediaItems.length;
  //showFirstItemRef指向展示列表中第一个品在商品列表中的index
  const showFirstItemRef = useRef(0);
  //showLastItemRef指向展示列表中最后一个品在商品列表中的index，当图片列表长度大于7时初始值为6,图片列表长度小于7时初始值为列表长度-1
  let showLastItemRef = useRef(0);
  //slider自适应
  const sliderRef = useRef(null);
  //每次透出的item个数
  const [showItemNumber, setShowItemNumber] = useState(0);
  const skuStore = SkuStore((state) => state);
  const skuInfo = skuStore.product;
  // 如果sku为true，只展示sku图片，用detail-sku-image容器装
  const isSku = skuInfo?.skuShowType === 'sku';

  // 数据初始化
  useEffect(() => {
    //@ts-ignore
    const itemNumber = Math.floor(sliderRef.current?.offsetHeight / ITEMS_HEIGHT);
    setShowItemNumber(itemNumber);
    if (ImageListLength > itemNumber) {
      showLastItemRef.current = itemNumber - 1;
    } else {
      showLastItemRef.current = ImageListLength - 1;
    }
  }, []);

  useEffect(() => {
    if (activeId < showFirstItemRef.current) {
      clickPrevArrow(activeId);
    } else if (activeId > showLastItemRef.current) {
      clickNextArrow(activeId);
    }
  }, [activeId]);

  //每次网页宽度变化时更新slider的高度sliderRef
  useEffect(() => {
    if (sliderRef.current === null) return;
    const handleResize = throttle(() => {
      //@ts-ignore
      const itemNumber = Math.floor(sliderRef.current?.offsetHeight / ITEMS_HEIGHT);
      setShowItemNumber(itemNumber);
    }, 100);

    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  //图片渲染逻辑（图片type不同会加不同icon）
  const renderImage = (url: string, index: number, type: string) => {
    return (
      <div
        className={`main-item ${!isSku && activeId === index && 'actived'}`}
        key={index}
        onMouseEnter={() => {
          if (index <= showLastItemRef.current && index >= showFirstItemRef.current) {
            setActiveId(index);
            skuStore.setSkuImageNone('product');
            doLog(`/sc.details.main_image_list_${index}`);
          }
        }}
        onClick={(e) => {
          //阻止元素默认行为
          e.preventDefault();
          if (type === 'live') {
            const v = document.querySelector('.bc-video-player video') as any;
            //将视频静音
            if (v) v.muted = true;
            // 分派自定义事件“live-main-enter”
            window.dispatchEvent(new CustomEvent('live-main-enter', { detail: '' }));
          } else {
            window.dispatchEvent(new CustomEvent('live-main-exit', { detail: '' }));
          }
          skuStore.setSkuImageNone('product');
        }}
      >
        {/* 如果当前list-item是视频 */}
        {type === 'video' && <DetailIcon symbol={'icon-play-fill'} className={'detail-symbol'} />}

        {/* 如果当前list-item是真人接待*/}
        {type === 'live' ? (
          <div
            className="live-list-item"
            style={{
              backgroundImage: `url(${url})`,
            }}
          >
            <img
              className="live-img"
              src="https://s.alicdn.com/@img/imgextra/i3/O1CN013pJu0Z259ivVFqtzv_!!6000000007484-1-tps-48-48.gif"
            />
          </div>
        ) : (
          <>
            <img className="image-list-item" loading="lazy" src={url} />
            <div className="image-list-item-mask"></div>
          </>
        )}
      </div>
    );
  };

  //点击上滑按钮，改变展示列表上下指针和滑动距离，如果activeId小于当前first指针，则将activeId当前值传进来
  const clickPrevArrow = (index?: number) => {
    if (showFirstItemRef.current > showItemNumber) {
      showFirstItemRef.current -= showItemNumber;
      showLastItemRef.current -= showItemNumber;
      setSwipeDistance(swipeDistance + showItemNumber * ITEMS_HEIGHT);
    } else {
      showFirstItemRef.current = 0;
      showLastItemRef.current = showItemNumber - 1;
      setSwipeDistance(0);
    }
    setActiveId(index === undefined ? showFirstItemRef.current : index);
  };
  //点击下滑按钮，改变展示列表上下指针和滑动距离
  const clickNextArrow = (index?: number) => {
    // TODO: 翻页到底部高度不够时，边界条件判断
    if (ImageListLength - showLastItemRef.current > showItemNumber) {
      showFirstItemRef.current += showItemNumber;
      showLastItemRef.current += showItemNumber;

      setSwipeDistance(swipeDistance - showItemNumber * ITEMS_HEIGHT);
    } else {
      showFirstItemRef.current += ImageListLength - showLastItemRef.current - 1;
      showLastItemRef.current = ImageListLength - 1;
      //@ts-ignore
      setSwipeDistance(sliderRef.current?.offsetHeight - ImageListLength * ITEMS_HEIGHT + 20);
    }
    setActiveId(index === undefined ? showFirstItemRef.current : index);
  };

  const CustomPrevArrow = () => {
    return (
      <div className={`top-container ${showFirstItemRef.current === 0 ? 'disabled' : ''}`}>
        <div className="top-mask"></div>
        <div
          className={`arrow-link arrow-link-top `}
          onClick={(e) => {
            e.preventDefault();
            clickPrevArrow();
          }}
        >
          <DetailIcon symbol={'icon-up'} className={'detail-symbol'} />
        </div>
      </div>
    );
  };

  const CustomNextArrow = () => {
    return (
      <div
        className={`bottom-container ${
          showLastItemRef.current === ImageListLength - 1 ? 'disabled' : ''
        }`}
      >
        <div className="bottom-mask"></div>
        <div
          className={`arrow-link arrow-link-bottom `}
          onClick={(e) => {
            e.preventDefault();
            clickNextArrow();
          }}
        >
          <DetailIcon symbol={'icon-down'} className={'detail-symbol'} />
        </div>
      </div>
    );
  };

  return (
    <div className="image-list" ref={sliderRef}>
      <CustomPrevArrow />
      <div className="image-list-slider" style={{ transform: `translateY(${swipeDistance}px)` }}>
        {mediaItems &&
          mediaItems.map((item, index) =>
            // @ts-ignore
            renderImage(resetUrl(getUrl(item), '140'), index, item?.type),
          )}
      </div>
      <CustomNextArrow />
    </div>
  );
}
